import i18n from '@/config/locale'
import LinkModel from './LinkModel'

export default (player) => {
  if (!player) return

  player.original_job = player.job
  player.job = player.job || i18n.t('player.no_job')

  if (player.links) {
    player.links = player.links.map(link => LinkModel(link))
  }

  return Object.defineProperties(player, {
    name: {
      get() {
        return this.firstname + ' ' + this.lastname
      }
    },

    initials: {
      get() {
        return this.firstname[0] + this.lastname[0]
      }
    },

    league_promo: {
      get() {
        return this.league.name + ' P' + this.graduating_year
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/services/Models/PlayerModel.js